const Retirement401KInitialArray =[
    {savingsType: "default", totalSavingsAmt: 0, currentPrice: 0, quantity: 0, 
        startPrice: 0, totalMatchAmt: 0, companyMatchRate: 0, depositPercent: 0,
        oneTimeDepositAmt: 0, monthlyDepositAmt: 0, prevTransferAmt: 0,
        prevTransferFees: 0, newTransferAmt: 0, newTransferFee: 0, nbrTransfers: 0, 
        currentMonthlyAmt: 0, updated: false, yearArr: [], totalDeposited: 0,
        createNewElementSw: true, svgIndx: null, startDate: "", savingsClass: ""},
 
  ]
export default Retirement401KInitialArray;